import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";

const PATH = "account-apps-user";

@Injectable({
  providedIn: "root",
})
export class AccountAppUserHandlerService {
  constructor(private ApiService: ApiService) {}

  getSignalHistory(masterAccountID: number, accountAppUserID: number) {
    return this.ApiService.get(
      `${PATH}/${masterAccountID}/user/${accountAppUserID}/signal-history`,
    );
  }

  getLocationHistory(
    masterAccountID: number,
    accountAppUserID: number,
    facilityIDs?: number[],
  ) {
    return this.ApiService.get(
      `${PATH}/${masterAccountID}/user/${accountAppUserID}/location-history`,
    );
  }

  getUser(masterAccountID: number, accountAppUserID: number) {
    return this.ApiService.get(
      `${PATH}/${masterAccountID}/user/${accountAppUserID}`,
    );
  }
}
